/* eslint-disable */ 

import React from 'react'
import CIcon from '@coreui/icons-react'
import {
  cilBell,
  cilCalculator,
  cilChartPie,
  cilCursor,
  cilDrop,
  cilList,
  cilNotes,
  cilPencil,
  cilContact,
  cilPuzzle,
  cilSpeedometer,
  cilStar,
  cilBuilding,
  cilPeople,
  cilThumbUp,
  cilThumbDown,
  cilSettings,
  cilReportSlash,
  cilSpreadsheet
} from '@coreui/icons'
import { CNavGroup, CNavItem, CNavTitle } from '@coreui/react'

export const _nav = [
  {
    component: CNavItem,
    name: 'Dashboard',
    to: '/dashboard',
    icon: <CIcon icon={cilSpeedometer} customClassName="nav-icon" />,
/*     badge: {
      color: 'info',
      text: 'NEW',
    }, */
  },
  {
    component: CNavTitle,
    name: 'Tickets',
  },
  {
    component: CNavItem,
    name: 'Ticket List',
    to: '/tickets',
    icon: <CIcon icon={cilList} customClassName="nav-icon" />,
  },
  {
    component: CNavTitle,
    name: 'Customers',
  },
  {
    component: CNavItem,
    name: 'Sites',
    to: '/sites',
    icon: <CIcon icon={cilBuilding} customClassName="nav-icon" />
  },
  {
    component: CNavItem,
    name: 'Staff',
    to: '/staff',
    icon: <CIcon icon={cilPeople} customClassName="nav-icon" />
  },
  {
    component: CNavTitle,
    name: 'Reports',
  },
  {
    component: CNavItem,
    name: 'Throughput',
    to: '/throughputreport',
    icon: <CIcon icon={cilSpreadsheet} customClassName="nav-icon" />
  },
  {
    component: CNavTitle,
    name: 'Internal',
  },
  {
    component: CNavItem,
    name: 'Config',
    to: '/config',
    icon: <CIcon icon={cilSettings} customClassName="nav-icon" />
  }
]

export const _navFeedback = [

  {
    component: CNavTitle,
    name: 'Feedback'
  },
  {
    component: CNavItem,
    name: `Compliments`,
    to: '/feedback?feedback=compliment',
    icon: <CIcon icon={cilThumbUp} customClassName="nav-icon" />
  },
  {
    component: CNavItem,
    name: 'Complaints',
    to: '/feedback?feedback=complaint',
    icon: <CIcon icon={cilThumbDown} customClassName="nav-icon" />
  },
  
] 

export default _nav